<template>
  <div class="main">
    <!-- <el-card> -->
    <!-- <el-row :gutter="20">
        <el-col :span="8" :offset="8">
          <el-input
            type="textarea"
            :rows="18"
            placeholder="请输入数据，每行一条数据，每列以英文逗号隔开"
            v-model="sourcedata"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="分隔符" v-model="flag"></el-input>
        </el-col>
      </el-row> -->
    <!-- </el-card> -->
    <!-- <el-card style="margin-top: 20px"> -->
    <!-- <el-menu
  mode="horizontal"
  text-color="#fff"
  background-color="#96b97d">
  <el-menu-item ><div class="logo">
    模板转换器
    </div></el-menu-item>
</el-menu> -->
    <div class="header">
      <div>模板转换器</div>
    </div>
    <el-row style="margin-top: 20px" gutter="20">
      <el-col :span="6" offset="2">
        <div class="info info1">数据区</div>
        <el-input
          type="textarea"
          :rows="30"
          placeholder="请输入数据，每行一条数据，每列以英文逗号隔开"
          v-model="sourcedata"
        ></el-input>
      </el-col>
      <el-col :span="6">
        <div class="info info2">模板区</div>
        <div>
          <el-input type="textarea" :rows="30" v-model="templatestr"></el-input>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="info info3">结果区</div>
        <div>
          <el-input type="textarea" :rows="30" v-model="resstr"></el-input>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="center">
          <!-- <el-button type="primary" @click="change">生成</el-button> -->
          <el-input placeholder="分隔符" v-model="flag">
            <template slot="append">
              <div @click="change" class="sc">生成</div>
            </template>
          </el-input>
        </div>
        <div class="al">
          <div class="temp">
            <el-button type="primary" @click="anli1">案例1：条件判断</el-button>
          </div>
          <div class="temp">
            <el-button type="primary" @click="anli2">案例2：下标索引</el-button>
          </div>
          <div class="temp">
            <el-button type="primary" @click="anli3">案例3：序列化</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- </el-card> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      sourcedata: 'true,60,李白\nfalse,80,吕布',
      templatestr:
        '{=true:真,=false:假,}+++{>80:优秀,>70:真棒,<=70:一般,}+++{姓名}',
      resstr: '',
      flag: ','
      // aa: ['一', '二', '三']
    }
  },
  created() {},
  mounted() {},
  methods: {
    anli1() {
      this.sourcedata = 'true,60,李白\nfalse,80,吕布'
      this.templatestr =
        '{=true:真,=false:假,}+++{>80:优秀,>70:真棒,<=70:一般,}+++{姓名}'
      this.resstr = ''
    },
    anli2() {
      this.sourcedata = 'true,60,李白\nfalse,80,吕布'
      this.templatestr = '第一列{0},\n第二列{1},\n第三列{2},'
      this.resstr = ''
    },
    anli3() {
      this.sourcedata = 'name\nage\nsex'
      this.templatestr = '"{0}":i.{0},'
      this.resstr = ''
    },
    change() {
      // this.sourcedata = ''
      console.log(this.sourcedata.split('\n'))
      const a = this.templatestr.split(/{.*?}/g)
      let c = ''
      for (let y = 0; y < this.formtdata.length; y++) {
        let b = ''
        const aa = this.formtdata[y]
        for (let i = 0; i < a.length - 1; i++) {
          // b += a[i] + this.searlize(aa[i], this.rule[i])
          if (this.rule[i].indexOf('，') > -1) {
            b += a[i] + this.searlizezw(aa[i], this.rule[i])
          } else if (this.rule[i].indexOf(',') > -1) {
            b += a[i] + this.searlize(aa[i], this.rule[i])
            // console.log('1111')
          } else if (/\d/.test(this.rule[i])) {
            b += a[i] + aa[this.rule[i]]
          } else {
            b += a[i] + aa[i]
            // console.log('这是')
            // console.log(a)
            // console.log(a[i])
            // console.log(aa)
            // console.log(this.rule[i])
          }
        }
        if (!this.templatestr.endsWith('}')) {
          b += a[a.length - 1]
        }
        c += b + '\n'
      }

      this.resstr = c
    },
    common(data) {
      // if (data.indexOf('=') > -1) {
      //   return data.replace('=', '==="')
      // }
      const gt = />\d/
      const lt = /<\d/
      const deng = /=\d/
      const gte = />=\d/
      const lte = /<=\d/
      if (gt.test(data) || lt.test(data) || deng.test(data)) {
        if (gte.test(data) || lte.test(data)) {
          return data
        }
        return data.replace('=', '===')
      } else {
        return data.replace('=', '==="') + '"'
      }
    },
    intpd(data) {
      const intreg = /^\d+$/
      if (intreg.test(data)) {
        return data
      }
      return '"' + data + '"'
    },
    searlize(odata, rule) {
      const rulelist = rule.split(',')
      // console.log(rulelist)
      let fnstr = ''
      for (let i = 0; i < rulelist.length; i++) {
        if (i === 0) {
          const condition = this.common(rulelist[0].split(':')[0])
          const res = rulelist[0].split(':')[1]
          fnstr += `if(${this.intpd(odata) + condition}){return ${
            '"' + res + '"'
          }}`
        } else if (i > 0 && i < rulelist.length - 1) {
          const condition = this.common(rulelist[i].split(':')[0])
          const res = rulelist[i].split(':')[1]
          fnstr += `else if(${this.intpd(odata) + condition}){return ${
            '"' + res + '"'
          }}`
        } else {
          fnstr += `else {return ${'"' + odata + '"'}}`
        }
      }
      console.log(fnstr)
      const fn = new Function(fnstr)()
      // console.log(odata, rule)
      return fn
    },
    searlizezw(odata, rule) {
      const rulelist = rule.split('，')
      // console.log(rulelist)
      let fnstr = ''
      for (let i = 0; i < rulelist.length; i++) {
        if (i === 0) {
          const condition = this.common(rulelist[0].split('：')[0])
          const res = rulelist[0].split('：')[1]
          fnstr += `if(${this.intpd(odata) + condition}){return ${
            '"' + res + '"'
          }}`
        } else if (i > 0 && i < rulelist.length - 1) {
          const condition = this.common(rulelist[i].split('：')[0])
          const res = rulelist[i].split('：')[1]
          fnstr += `else if(${this.intpd(odata) + condition}){return ${
            '"' + res + '"'
          }}`
        } else {
          fnstr += `else {return ${'"' + odata + '"'}}`
        }
      }
      console.log(fnstr)
      const fn = new Function(fnstr)()
      // console.log(odata, rule)
      return fn
    }
  },
  computed: {
    formtdata: function () {
      const alist = []
      const hang = this.sourcedata.split('\n')
      for (let i = 0; i < hang.length; i++) {
        alist.push(
          // hang[i].indexOf(',') > -1 ? hang[i].split(',') : hang[i].split('，')
          hang[i].split(this.flag)
        )
      }
      return alist
    },
    rule: function () {
      const regtext = /[{](.*?)[}]/g
      // console.log(regtext.exec(this.templatestr))
      var pilist = []
      let r = ''
      while ((r = regtext.exec(this.templatestr))) {
        pilist.push(r[1])
      }
      return pilist
    }
  }
}
</script>

<style scoped>
.center {
  height: 100%;
  /* display: flex; */
  /* justify-content: center;
  align-items: center; */
}
.sc {
  cursor: pointer;
}
.logo {
  font-size: 18px;
  text-align: center;
}
.header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(to right, #ff9569 0%, #e92758 100%);
  /* background-image: linear-gradient(-90deg, #29bdd9 0%, #276ace 100%); */
}
.info {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #96b97d;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 20px;
}
.info1 {
  background-color: #2bafed;
}
.info2 {
  background-color: #fc3b3f;
}
.info3 {
  background-color: #8a55ec;
}
.al {
  margin-top: 30px;
}
.temp {
  margin-top: 20px;
}
</style>
